import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import {
    AUTH_SERVICE_IMPL,
    IAuthenticationService,
} from '../services/authentication/iauthentication.service';
import { UserRole } from '../types/user-role';
import { FlashMessageService } from '../modules/flash-message/flash-message.service';

@Injectable({
    providedIn: 'root',
})
export class ProviderAdminGuard  {
    constructor(
        @Inject(AUTH_SERVICE_IMPL) private _authService: IAuthenticationService,
        private _router: Router,
        private _flashMessageService: FlashMessageService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this._authService.currentUser;
        if (!currentUser) {
            this._router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        } else if (!currentUser.hasRoles([UserRole.ProviderAdmin])) {
            this._flashMessageService.showMessage(
                'Access denied',
                `You're not allowed to access this route`
            );
            this._router.navigate(['/dashboard']);
            return false;
        }

        return true;
    }
}
